<template lang='pug'>
	.container-fluid.p-0.push-wrapper
		.container
			.row
				.col
					.row
						.col-12.my-header.font-weight-bold
							| Ваши Чаты
					.row(v-if='loading').mt-5
						.loader_holder
							object(type="image/svg+xml" data="/assets/loaders/infinity.svg")
					.row(v-if='chats.length==0 && !loading').mt-5
						.col-sm
							.white_block 
								.row 
									.col-sm У вас нет чатов, либо они все выключены.
					.row(v-for="chat in chats" v-if="!loading").mt-5
						.col-sm-12.chat_name {{chat.name}}
						.col-sm-3
							.chats_holder
								div(v-for="room of rooms.filter(x=>x.chat_id == chat.id)" @click="changeRoom(chat.chat_key, room.id)" :class="{chat_room: true, selected: room.selected}")
									.name {{room.initiator_id<0?'Аноним':room.initiator_data.user_name}}
									.user_id Пользователь №{{room.initiator_id}}
						.col-sm-6.chat_holder
							div(:data-chatconnect="chat.chat_key" show-locator-data data-chatconnect-disable-locator data-chatconnect-token-postfix="admin" :cc="chat.chat_key" chat_type="desktop")
						.col-sm-3
							.notes
								.title Ваши заметки в переписке
								.notes_list
									.note(v-for="note of chat.room_notes")
										.removeNote(@click="removeNote(chat, note)").fal.fa-times
										.text(v-if="note.type=='text'") {{note.value}}
								.note_inputs
									textarea(v-model="new_note.text" placeholder="Напишите заметку")
									//- | файл
									//- input(type="file")
									//- | прикрепленное сообщение
									//- | сообщение
									button.addNote(@click="addNote(chat)" :disabled="!chat.room_id || chat.note_loading") Добавить заметку

		.container
			.row.align-items-center.justify-content-center
				.col-sm-6.col-md-auto.mt-6.mb-0.mb-md-6




</template>
<script>
import { Tooltip } from "element-ui";
import moment from "moment";
import apiDriver from '../../apiDriver';

export default {
	components: {
		[Tooltip.name]: Tooltip
	},

	data() {
		return {
			rooms: [],
			chats: [],
			loading: true,
			new_note: {
				text: ""
			}
		};
	},

	computed: {},

	mounted() {
		this.getChats();
	},

	methods: {
		async getChats(){
			let _chats = (await apiDriver.services.api.get("chatconnect", 'chats')).data.chats;
			let chats = [];
			for(let chat of _chats) {
				if(chat.enabled==1) {
					chat.room_notes = [];
					chat.note_loading = true;
					chats.push(chat);
					let rooms = (await apiDriver.services.api.get("chatconnect", 'getChatRooms', {chat_id: chat.id})).data.rooms;
					rooms = rooms.sort((x,y)=>y.id-x.id);
					this.rooms.push(...rooms);
					for(let room of this.rooms) room.selected = false;
				}
			}
			this.chats = chats;
			this.loading = false;
			// window.ChatConnect.init();
		},
		changeRoom(chat_key, chat_room_id){
			let id = document.querySelector("[data-chatconnect][cc='"+chat_key+"']").id;
			window.ChatConnect.chatStorage[id].switchRoom(chat_room_id);
			for(let room of this.rooms) room.selected = false;
			this.rooms.find(x=>x.id==chat_room_id).selected = true;
			let selected_chat = this.chats.find(x=>x.chat_key==chat_key);
			if(selected_chat){
				selected_chat.room_notes = [];
				selected_chat.note_loading = true;
				selected_chat.room_id = chat_room_id;
				this.getRoomNotes(selected_chat);
			} 
			this.$forceUpdate();
		},
		async addNote(chat){
			if(!this.new_note.text.replace(/\s/g, '')) return;
			chat.note_loading = true;
			let note = (await apiDriver.services.api.post("chatconnect", 'addRoomNote', {room_id: chat.room_id, type: 'text', value: this.new_note.text})).data.note;
			chat.room_notes.push(note);
			this.new_note.text = "";
			chat.note_loading = false;
			this.$forceUpdate();
		},
		async removeNote(chat, note){
			chat.room_notes = chat.room_notes.filter(x=>x.id!=note.id);
			(await apiDriver.services.api.post("chatconnect", 'removeRoomNote', {note_id: note.id}));
			this.$forceUpdate();
		},
		async getRoomNotes(chat){
			let x = (await apiDriver.services.api.get("chatconnect", 'getRoomNotes', {room_id: chat.room_id})).data.notes;
			chat.room_notes = x;
			chat.note_loading = false;
		}
	}
};
</script>
<style scoped lang="stylus">
	div{cursor: default;}
	.my-header{font-size: 26pt;}
	.header-pre-push{font-size: 1.5rem;}
	.header-push{font-size: 1.5rem;color: black}

	.chat_name{
		font-size: 20pt;
		margin-bottom: 10px;
		color: gray;
	}

	.chats_holder{
		background white;
		border-radius: 15px;
		height 500px;
	}
	.chat_holder{
		background white;
		border-radius: 15px;
		height 500px;
		padding: 0;
    	overflow: hidden;
	}

	.chats_holder{
		overflow hidden;
		overflow-y: scroll;
		.chat_room{
			padding: 5px 10px;
			border-bottom: 1px solid #eee;
			cursor pointer;
			.user_id{
				color: #929292;
				font-size: 9pt;
			}
			&:hover{
				background #eee;
			}
			&.selected{
				border-left: 4px solid #4CAF50;
				background white;
				cursor default;
			}
		}
	}
	
	.notes{
	    background: white;
		border-radius: 15px;
		overflow: hidden;
		height: 500px;
		.title{
			text-align: center;
			position: relative;
			top: 5px;
			color: gray;
			font-size: 9pt;
			height: 21px;
			font-weight: 600;
		}

		.notes_list{
			height: 390px;
			overflow: hidden;
			overflow-y: scroll;

			.note{
				margin: 5px 0;
				padding: 5px 10px;
				position: relative;
				border-left: 2px solid #dedede;

				.removeNote{
					position: absolute;
					right: 7px;
					cursor pointer;
					opacity: 0.1;
				}

				&:hover{
					background #f9f9f9;
					.removeNote{
						opacity: 0.5;
						&:hover{
							opacity: 1;
						}
					}
				}
			}
		}

		textarea{
			width: 100%;
			resize: none;
			border: none;
			border-top: 1px solid #eee;
			outline none;
			padding: 2px 5px;
		}
		.addNote{
			border: none;
			width: 100%;
			background: #2891d8;
			color: white;
			padding: 8px 0;
			outline none;
			&:hover{
				background: #1f81c3;
			}
			&[disabled]{
				cursor default;
				background #d2d2d2;
			}
		}
	}

</style>
